import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from "../../components/layout/header/Header";
import FooterTop from "../../components/layout/footer/FooterTop";

const MainPageLayout = ({hideFooter }) => {
    return (
        <>
            <Header />
            <Outlet />
            {!hideFooter && <FooterTop />}
        </>
    );
}

export default MainPageLayout;
